import { z } from 'zod';
import { ITEM_STATUSES, PRIORITIES } from './enums';
/* ---- Comments ----------------------------------------------------------- */
export const createCommentSchema = z.object({
    itemId: z.string().uuid(),
    body: z.string().min(1).max(5000).trim(),
});
export const updateCommentSchema = z.object({ body: z.string().min(1).max(5000).trim() });
/* ---- Dependencies ------------------------------------------------------- */
export const createDependencySchema = z.object({
    blockedItemId: z.string().uuid(),
    blockingItemId: z.string().uuid(),
});
/* ---- Bulk actions ------------------------------------------------------- */
export const bulkUpdateItemsSchema = z.object({
    itemIds: z.array(z.string().uuid()).min(1).max(200),
    patch: z
        .object({
        status: z.enum(ITEM_STATUSES).optional(),
        priority: z.enum(PRIORITIES).optional(),
        ownerId: z.string().uuid().nullable().optional(),
        dueDate: z.coerce.date().nullable().optional(),
        blockedReason: z.string().max(500).nullable().optional(),
    })
        .refine((patch) => Object.keys(patch).length > 0, 'Choose at least one change'),
});
export const bulkDeleteItemsSchema = z.object({
    itemIds: z.array(z.string().uuid()).min(1).max(200),
});
//# sourceMappingURL=collaboration.contract.js.map